export default __webpack_public_path__ + "static/media/status-notstarted.5e1f34ed.svg";